// 基础类型
export type EmojiSize = 'small' | 'medium' | 'large'
export type EmojiType = 'cube' | 'heygirl' | 'twemoji' | 'custom'

export const TWEmojiType = {
  '1': 'people',
  '2': 'natural',
  '3': 'food',
  '4': 'activity',
  '5': 'travel',
  '6': 'objects',
  '7': 'symbol',
  '8': 'flag',
}

export interface IHeyboxEmoji {
  code: string;
  img: string;
  name: string;
  type: number;
}

export interface IHeyboxEmojiGroup {
  group_code: string;
  group_img: string;
  group_name: string;
  type: number;
  emojis: IHeyboxEmoji[];
}

export interface LocalHeyboxEmoji {
  name: string;
  url: string;
  type: EmojiType;
  prefix?: string;
}

export interface CategoryEmoji extends LocalHeyboxEmoji {
  icon?: string;
  en_name?: string;
}

export interface CategoryItem {
  name: string;
	title: string;
	type: string;
	prefix: string;
	size: string;
  img?: string;
	ext?: string;
  isCustom?: boolean;
	list?: CategoryEmoji[];
}


export const CUSTOM_EMOJI_HOST = 'https://chat.max-c.com/pic/'